import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import invoiceService from "../services/invoiceService";

/**
 * Hook personalizado para manejar el estado y operaciones de facturas
 */
export const useInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Estados de paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);

  /**
   * Carga las facturas desde la API
   */
  const fetchInvoices = async (page = 1) => {
    setLoading(true);
    try {
      const data = await invoiceService.fetchInvoices(page, fromDate, toDate);
      
      if (data.data) {
        setInvoices(data.data);
        setCurrentPage(data.current_page);
        setTotalPages(data.last_page);
        setTotal(data.total);
        setFrom(data.from);
        setTo(data.to);
      } else {
        const invoicesData = data ?? [];
        setInvoices(Array.isArray(invoicesData) ? invoicesData : []);
      }
    } catch (error) {
      console.error("Error al cargar facturas:", error);
      Swal.fire("Error", "No se pudieron cargar las facturas", "error");
    } finally {
      setLoading(false);
    }
  };

  /**
   * Obtiene todas las facturas (para exportar)
   */
  const fetchAllInvoices = async () => {
    const data = await invoiceService.fetchAllInvoices(fromDate, toDate);
    return Array.isArray(data) ? data : [];
  };

  /**
   * Cambia de página
   */
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchInvoices(newPage);
    }
  };

  /**
   * Aplica filtros de búsqueda
   */
  const handleSearch = () => {
    setCurrentPage(1);
    fetchInvoices(1);
  };

  /**
   * Limpia los filtros
   */
  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    fetchInvoices(1);
  };

  // Cargar facturas al montar el componente
  useEffect(() => {
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // Estado
    invoices,
    loading,
    fromDate,
    toDate,
    currentPage,
    totalPages,
    total,
    from,
    to,
    
    // Setters
    setFromDate,
    setToDate,
    
    // Funciones
    fetchInvoices,
    fetchAllInvoices,
    handlePageChange,
    handleSearch,
    handleClearFilters
  };
};